// Transparent PNG logo - background removed
export const LOGO_BASE64 = process.env.PUBLIC_URL + '/logo.png';
export const FAVICON_BASE64 = process.env.PUBLIC_URL + '/favicon.png';
